export default __webpack_public_path__ + "static/s13-ba6dce51b757dd41b33ab0c958dfe088.png";